<template>
  <div>
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Match Options
          </div>
        </template>
      </es-header>
    </div>
    <div class="tabs-container no-border-top">
      <es-tabs :tabs="availableTabs" ref="tabs"></es-tabs>
    </div>
  </div>
</template>

<script>
import EsHeader from '@/components/EsHeader.vue';
import PermissionManager from '@/mixins/PermissionManager';
import EsTabs from '@/components/EsTabs.vue';

export default {
  mixins: [
    PermissionManager,
  ],
  components: {
    EsHeader,
    EsTabs,
  },
  watch: {
    '$route': 'selectTab',
  },
  data() {
    return {
      tabs: [],
    };
  },
  created() {
    this.tabs = [
      {
        isAvailable: this.hasModule('DRMCH:MATCH:OPTIONS:PERSONTAB:VIEW'),
        name: 'dmMatchOptionsPerson',
        label: 'PERSON',
      },
      {
        isAvailable: this.hasModule('DRMCH:MATCH:OPTIONS:ADDRESS:VIEW'),
        name: 'dmMatchOptionsAddress',
        label: 'ADDRESS',
      },
    ];
  },
  computed: {
    availableTabs() {
      return this.tabs.filter(tab => tab.isAvailable);
    },
  },
  methods: {
    selectTab() {
      if (this.$route.name === 'dmMatchOptions') {
        if (this.hasModule('DRMCH:MATCH:OPTIONS:PERSONTAB:VIEW')) {
          this.$router.replace({ name: 'dmMatchOptionsPerson' });
        } else if (this.hasModule('DRMCH:MATCH:OPTIONS:ADDRESS:VIEW')) {
          this.$router.replace({ name: 'dmMatchOptionsAddress' });
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
